export default __webpack_public_path__ + "static/media/cross.5750a4e1.svg";